import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SinaWeibo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.688 10.068c-.274-.084-.463-.142-.319-.508.311-.797.344-1.484.007-1.975-.633-.92-2.364-.871-4.348-.025 0-.002-.623.277-.464-.227.306-.997.259-1.833-.216-2.315-1.076-1.098-3.937.041-6.392 2.539C1.117 9.428.05 11.41.05 13.125c0 3.281 4.132 5.475 8.175 5.475 5.299 0 8.825-3.334 8.825-5.822 0-1.505-1.244-2.358-2.362-2.71zm-6.452 7.061c-3.225.32-6.011-1.147-6.22-3.275-.209-2.129 2.236-4.115 5.462-4.438 3.226-.32 6.011 1.146 6.22 3.275.209 2.131-2.236 4.118-5.462 4.438zM19.95 7.397a5.998 5.998 0 00-6-5.996.698.698 0 100 1.398 4.602 4.602 0 014.601 4.602.699.699 0 101.399-.001v-.003zm-2.781-.102a4.006 4.006 0 00-3.113-3.113.7.7 0 10-.281 1.371 2.603 2.603 0 012.024 2.023.701.701 0 00.826.545.701.701 0 00.544-.826zM6.582 11.502c-1.3.262-2.177 1.352-1.959 2.434.218 1.084 1.447 1.75 2.747 1.488 1.299-.262 2.176-1.352 1.959-2.434-.218-1.082-1.449-1.75-2.747-1.488z"
  }));
});
SinaWeibo.displayName = 'SinaWeibo';
export var SinaWeiboDimensions = {
  height: 20,
  width: 20
};